// extracted by mini-css-extract-plugin
export default {"descriptionList":"BankInquiryApplication_descriptionList__9mQST","pageContent":"BankInquiryApplication_pageContent__Jqi+5"};